import React from 'react';
import { DropdownItem } from 'reactstrap';
import AddOrg from '../../AddOrg/index';
import ListRowImage from 'components/listRowImage';
import ListRowFavourite from 'components/ListRowFavourite';
import ListRowCheckbox from 'components/ListRowCheckbox';
import ListRowDropdown from 'components/ListRowDropdown';
import ListRowData from 'components/ListRowData';

class OrgRow extends React.Component {

    onOrgOptionToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };

    onOrgClose = () => {
        this.setState({ addOrgState: false });
    };
    onDeleteOrg = (org) => {
        this.setState({ addOrgState: false });
        this.props.onDeleteOrg(org);
    };

    // onEmpDashboard = (org) => {
    //     this.setState({ addOrgState: false });
    //     this.props.onEmpDashboard(org);
    //     history.push('/app/employee/default');
    // };

    // onOrgSurveyDashboard = (org) => {
    //     this.setState({ addOrgState: false });
    //     this.props.onOrgSurveyDashboard(org);
    //     history.push('/app/org-survey/default');
    // };

    // onProjectDashboard = (org) => {
    //     this.setState({ addOrgState: false });
    //     this.props.onProjectDashboard(org); // set the selected org
    //     history.push('/app/project/default'); // goto the project view
    // };

    onImpersonateOrg = (org) => {
        this.setState({ addOrgState: false });
        this.props.onClearSelectedObjects();
        this.props.onImpersonateOrg(org);
    };

    onEditOrg = () => {
        this.setState({ menuState: false, addOrgState: true });
    };

    constructor() {
        super();
        this.state = {
            menuState: false,
            addOrgState: false,
        };
    }

    render() {
        const { width, organisation, addFavouriteOrg, onOrgSelect, onSaveOrg, showOrgLoader } = this.props;
        const { menuState, addOrgState } = this.state;
        const { name, email, phone, starred } = organisation;
        const options = [
            'Edit',
            'Delete',
            'Impersonate'
        ];
        return (

            <div className="contact-item">

                <ListRowCheckbox selected={organisation.selected} onClick={() => { onOrgSelect(organisation); }} />
                <ListRowFavourite width={width} onClick={() => { addFavouriteOrg(organisation); }} starred={starred} />
                <ListRowImage width={width} data={organisation} />
                <ListRowData lineOne={name} lineTwoLeft={email} lineTwoRight={phone} />
                <ListRowDropdown
                    menuState={menuState}
                    toggle={this.onOrgOptionToggle.bind(this)}
                    options={options}
                    dropdownItems={options.map(option =>
                        <DropdownItem key={option} onClick={() => {
                            if (option === 'Edit') {
                                this.onEditOrg();
                            } else if (option === 'Delete') {
                                this.onDeleteOrg(organisation);
                            } else if (option === 'Impersonate') {
                                this.onImpersonateOrg(organisation);
                            }
                        }
                        }>
                            {option}
                        </DropdownItem>,
                    )}
                />
                <div>
                    {addOrgState &&
                        <AddOrg open={addOrgState} organisation={organisation} onSaveOrg={onSaveOrg}
                            onOrgClose={this.onOrgClose} onDeleteOrg={this.onDeleteOrg}
                            showOrgLoader={showOrgLoader} />}
                </div>
            </div>
        );
    }
}

export default OrgRow;


// WEBPACK FOOTER //
// ./components/Agile/Organisation/OrgList/OrgRow/index.js